import React from "react";
import { Box, Text, useColorModeValue } from "@chakra-ui/react";
import { Bar, BarChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";

const RiskReviewMonthlyChart = ({ data = [] }) => {
  const cardBg = useColorModeValue("white", "gray.800");
  const borderColor = useColorModeValue("gray.200", "gray.700");

  return (
    <Box bg={cardBg} borderWidth="1px" borderColor={borderColor} borderRadius="md" p={4} boxShadow="sm">
      <Text fontWeight="semibold" mb={3}>
        Completion by Month
      </Text>
      <Box h="260px">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={Array.isArray(data) ? data : []}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="label" />
            <YAxis />
            <Tooltip />
            <Bar dataKey="value" fill="#3182ce" name="Requests" />
          </BarChart>
        </ResponsiveContainer>
      </Box>
    </Box>
  );
};

export default RiskReviewMonthlyChart;
